import React from "react";
import Accordion from "../../accordion";
import { DEFAULT_LOCALE, sortByLocale } from "../../photography/lib/helpers";
import ImageList from "./image-list";

const LocaleList = ({ imageClick, shots, filterEmpty, shipmentKey, shipmentProductKey, isFinalQa }) => {
    if (shots.length <= 0) {
        return null;
    }

    const shotsByLocale = sortByLocale(shots);
    const imageLists = Object.keys(shotsByLocale).map((key) => {
        const localeShots = shotsByLocale[key];
        const locale = localeShots[0].locale || DEFAULT_LOCALE.text;

        return (
            <ImageList
                key={`localeList_${key}`}
                shots={localeShots}
                label={locale}
                imageClick={imageClick}
                filterEmpty={filterEmpty}
                shipmentKey={shipmentKey}
                shipmentProductKey={shipmentProductKey}
                isFinalQa={isFinalQa}
            />
        );
    });

    return <Accordion openAll={true}>{imageLists}</Accordion>;
};

export default LocaleList;
